const firebase = require("firebase/app");
require("firebase/database");
require("firebase/storage");

const getImageUrl = url => {
  let storage = firebase.storage();
  let pathReference = null;
  try {
    pathReference = storage.ref("images/" + url);
  } catch (e) {
    console.error("error while getting image ref: ", url, e);
  }
  return pathReference;
};

async function asyncForEach(array, callback) {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index]);
  }
}

export const getImages = (id, imagesCallback) => {
  let images = [];
  var storageRef = firebase
    .storage()
    .ref()
    .child("biens/" + id);
  storageRef.listAll().then(res => {
    asyncForEach(res.items, file => {
      file.getDownloadURL().then(downloadUrl => {
        images.push(downloadUrl);
      });
    }).then(() => {
      imagesCallback(images);
    });
  });
};

// export const getStoredImage = () => {};

export default getImageUrl;
